export enum EIconColors {
  BLACK = 'black',
  GREEN = 'green',
  RED = 'red',
  BLUE = 'blue',
  WHITE = 'white'
}
